(() => {
  const footer = document.querySelector('.footer--premium');
  if (!footer) return;

  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const toggles = Array.from(footer.querySelectorAll('.vv-footer-premium__menu .collapsible'));

  const syncToggle = (toggle) => {
    const expanded = !mobileQuery.matches || toggle.classList.contains('active');
    toggle.setAttribute('aria-expanded', String(expanded));
  };

  toggles.forEach((toggle) => {
    syncToggle(toggle);
    toggle.addEventListener('click', () => {
      window.requestAnimationFrame(() => syncToggle(toggle));
    });
  });

  const syncAll = () => toggles.forEach(syncToggle);
  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncAll);
  } else {
    mobileQuery.addListener(syncAll);
  }
})();
